export default "__VITE_ASSET__ChlW8oJV__"